import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {PaywallService} from '@core/services/limits/paywall.service';
import {LimitExceededResponse} from '@core/models/payment.model';

/**
 * Перехватывает 402 Payment Required и сигналит PaywallService для открытия модалки.
 * Ошибка не подавляется — исходный поток получает её дальше, чтобы вызывающий мог откатить UI-стейт.
 */
@Injectable()
export class LimitExceededInterceptor implements HttpInterceptor {
  constructor(private paywall: PaywallService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 402 && err.error?.error === 'limit_exceeded') {
          this.paywall.trigger(err.error as LimitExceededResponse);
        }
        return throwError(err);
      })
    );
  }
}
